import React from 'react';

/*
  About — about page extracted from App.js.
  Props: goBack, navigateTo
*/
const About = ({ goBack, navigateTo }) => {
  return (
        <section style={{ minHeight: '100vh', backgroundColor: 'var(--bg)', paddingTop: '64px' }}>
          <div style={{ maxWidth: '680px', margin: '0 auto', padding: '64px 24px 120px' }}>

            {/* Back */}
            <button
              onClick={() => goBack('company')}
              style={{ background: 'none', border: 'none', color: 'var(--text-tertiary)', fontSize: '13px', fontWeight: 500, cursor: 'pointer', padding: 0, marginBottom: '48px', fontFamily: 'inherit', transition: 'color 0.2s' }}
              onMouseEnter={e => e.currentTarget.style.color = 'var(--text-primary)'}
              onMouseLeave={e => e.currentTarget.style.color = 'var(--text-tertiary)'}
            >← Back</button>

            {/* Heading */}
            <h1 style={{ fontFamily: 'Georgia, "Times New Roman", serif', fontSize: 'clamp(28px, 4vw, 42px)', fontWeight: 400, color: 'var(--text-primary)', lineHeight: 1.2, margin: '0 0 40px', letterSpacing: '-0.01em' }}>
              About Axigon AI
            </h1>

            {/* Body copy */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: '20px', marginBottom: '56px' }}>
              <p style={{ fontSize: '16px', color: 'var(--text-secondary)', lineHeight: 1.8, margin: 0 }}>
                Axigon AI is building a suite of personal AI tools designed for the Indian context — people who deal with GST filings, salary negotiations, SIP decisions, and legal paperwork without access to expensive advisors. We believe that kind of expertise should not be a privilege.
              </p>
              <p style={{ fontSize: '16px', color: 'var(--text-secondary)', lineHeight: 1.8, margin: 0 }}>
                We started with two products: Ask Axigon Finance, which reads your bank statements and gives you an honest picture of your financial health, and Legal GPT, which answers questions about Indian business law in plain language. Both are early. We are improving them based on real usage, not demos.
              </p>
            </div>

            {/* Divider */}
            <div style={{ borderTop: '1px solid var(--border)', marginBottom: '48px' }} />

            {/* What's coming */}
            <div>
              <p style={{ fontSize: '11px', fontWeight: 700, color: 'var(--text-tertiary)', textTransform: 'uppercase', letterSpacing: '0.12em', margin: '0 0 28px' }}>What's coming</p>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '0' }}>
                {[
                  { name: 'Career Co-Pilot', desc: 'Benchmark your salary against the market, identify skill gaps, and prepare for negotiations.' },
                  { name: 'GST Compliance', desc: 'Track GST deadlines, flag anomalies in your filings, and explain notices in plain language.' },
                  { name: 'HR Agent', desc: 'Help small businesses draft compliant offer letters, policies, and handle common HR queries.' },
                  { name: 'Decision Intelligence', desc: 'Model major life decisions — buying a home, switching jobs, starting a business — with real numbers.' },
                ].map(({ name, desc }, i, arr) => (
                  <div key={name} style={{ padding: '20px 0', borderBottom: i < arr.length - 1 ? '1px solid #141416' : 'none', display: 'flex', flexDirection: 'column', gap: '6px' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                      <span style={{ fontSize: '14px', fontWeight: 600, color: 'var(--text-primary)' }}>{name}</span>
                      <span style={{ fontSize: '10px', fontWeight: 700, color: 'var(--text-tertiary)', border: '1px solid var(--border)', borderRadius: '4px', padding: '2px 7px', letterSpacing: '0.08em', textTransform: 'uppercase' }}>Soon</span>
                    </div>
                    <p style={{ fontSize: '13px', color: 'var(--text-secondary)', lineHeight: 1.65, margin: 0 }}>{desc}</p>
                  </div>
                ))}
              </div>
            </div>

            {/* Copyright */}
            <p style={{ fontSize: '12px', color: 'var(--text-tertiary)', margin: '48px 0 0', textAlign: 'center' }}>© 2026 Axigon AI</p>

          </div>
        </section>
  );
};

export default About;
